// Header titles
export const HEADER_TITLE = 'Send Time Optimization Insights';
export const MAIN_HEADER_TIME_RANGE_TITLE = 'Viewing';

// Trends section
export const STO_TRENDS_LEFT_TITLE = 'Send time distribution over time';
export const STO_TRENDS_RIGHT_TITLE = 'View trends by';
export const STO_TREND_CSV_EXPORT_SUCCESS = 'STO trends data exported successfully';

// Breakdown section
export const BREAKDOWN_BY_CHANNEL = 'Breakdown by Channel';
export const EXPORT_CSV = 'Export CSV';

// Test IDs
export const STO_PERFORMANCE_METRIC_CARDS_TEST_ID = 'sto-performance-metric-cards-section';
export const STO_PERFORMANCE_METRIC_LIFT = 'sto-performance-metric-lift';
export const STO_PERFORMANCE_METRIC_CHANGE = 'sto-performance-metric-change';
export const STO_BIGGEST_LIFT_LINK = 'sto-biggest-lift-link';
export const STO_BIGGEST_CHANGE_LINK = 'sto-biggest-change-link';

// Empty state messages
export const NO_STO_DATA_TITLE = 'No STO data available';
export const NO_STO_DATA_BODY = "We couldn't find any STO data for the selected time period.";
export const NO_STO_DATA_LINK = 'Learn more about STO in our';

// Error messages
export const STO_ERROR_FETCHING_PAGE = 'We had a problem fetching this page.';
export const STO_ERROR_CLICK_HERE = 'Click here';
export const STO_ERROR_TO_GO = 'to go';

// Not enabled messages
export const STO_NOT_ENABLED = 'Send Time Optimization not enabled';
export const STO_NOT_ENABLED_CONTACT_CSM =
  'Contact your Customer Success Manager to enable Send Time Optimization.';
export const STO_NOT_ENABLED_LEARN_MORE = 'Learn more about STO in our';
export const STO_NOT_ENABLED_KNOWLEDGE_CENTER = 'Knowledge Center';
